module.exports = __webpack_public_path__ + "img/5.746821e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/5.png
// module id = 341
// module chunks = 1